import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { Document, Page, pdfjs } from "react-pdf";


import gstPdf from "../../images/gst-certificate/gst-certificate.pdf";
import gstPreview from "../../images/gst-certificate/gst-preview.png";

// Configure PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const GstCertification = () => {
    const [showPdf, setShowPdf] = useState(false);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }


    return (
        <section className="gst-section reveal">
            {/* Glowing background circles */}
            <div className="gst-bg-circle"></div>
            <div className="gst-bg-circle second"></div>

            <div className="gst-content">
                {/* LEFT SIDE - Image */}
                <div className="gst-image">
                    <div className="gst-badge">
                        VERIFIED
                    </div>
                    <a
                        href={gstPdf}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <a
                            href={`${gstPdf}#toolbar=0&navpanes=0&scrollbar=0`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="gst-image-link"
                        >
                            <img src={gstPreview} alt="GST Certificate" />
                        </a>

                    </a>
                </div>

                {/* RIGHT SIDE - Text */}
                <div className="gst-text">
                    <span className="gst-subtitle">
                        Government Registered Exporter
                    </span>
                    <h2>GST Certification</h2>
                    <p>
                        Unique Global Exports is officially GST registered and
                        compliant with Indian export regulations. Our certification
                        reflects transparency, trust, and commitment to secure
                        international trade operations.
                    </p>

                    <div className="gst-features">
                        <div className="gst-feature">
                            <FontAwesomeIcon icon={faCheckCircle} className="check-icon" />
                            Trusted Export Business
                        </div>
                        <div className="gst-feature">
                            <FontAwesomeIcon icon={faCheckCircle} className="check-icon" />
                            Government Verified
                        </div>
                        <div className="gst-feature">
                            <FontAwesomeIcon icon={faCheckCircle} className="check-icon" />
                            Transparent Documentation
                        </div>
                    </div>

                    <div className="gst-buttons">
                        <a
                            href={`${gstPdf}#toolbar=0&navpanes=0&scrollbar=0`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="gst-btn"
                        >
                            View Certificate
                        </a>
                    </div>
                </div>
            </div>

            <style jsx>{`
        /* GST SECTION */
        .gst-section {
          position: relative;
          padding: 100px 8%;
          overflow: hidden;
        }

        /* Glowing circles */
        .gst-bg-circle {
          position: absolute;
          width: 300px;
          height: 300px;
          background: rgba(34, 197, 94, 0.12);
          border-radius: 50%;
          filter: blur(80px);
          top: 0;
          left: -100px;
        }

        .gst-bg-circle.second {
          background: rgba(59, 130, 246, 0.12);
          right: -100px;
          left: auto;
          bottom: 0;
          top: auto;
        }

        .gst-content {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: center;
          gap: 70px;
          background: rgba(255, 255, 255, 0.65);
          backdrop-filter: blur(18px);
          border: 1px solid rgba(255, 255, 255, 0.3);
          border-radius: 32px;
          padding: 50px;
          box-shadow:
            0 10px 40px rgba(0, 0, 0, 0.08),
            inset 0 1px 1px rgba(255, 255, 255, 0.4);
        }

        /* IMAGE */
        .gst-image {
          flex: 1;
          position: relative;
        }

        .gst-image a {
          display: block;
          position: relative;
          text-decoration: none;
        }

        .gst-image img {
          width: 100%;
          max-width: 380px;
          border-radius: 22px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18);
          transition: 0.4s ease;
        }

        .gst-image:hover img {
          transform: translateY(-8px) scale(1.02);
        }

        /* Verified badge */
        .gst-badge {
          position: absolute;
          top: -15px;
          right: 30px;
          z-index: 5;
          background: linear-gradient(90deg, #22c55e, #16a34a);
          color: white;
          padding: 10px 18px;
          border-radius: 50px;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 1px;
          box-shadow: 0 10px 20px rgba(34, 197, 94, 0.3);
        }

        /* TEXT */
        .gst-text {
          flex: 1;
        }

        .gst-subtitle {
          display: inline-block;
          color: #22c55e;
          font-size: 14px;
          font-weight: 700;
          margin-bottom: 12px;
          letter-spacing: 1px;
          text-transform: uppercase;
        }

        .gst-text h2 {
          font-size: 42px;
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 20px;
          color: #0f172a;
        }

        .gst-text p {
          font-size: 17px;
          line-height: 1.8;
          color: #525252;
          margin-bottom: 28px;
        }

        /* Features */
        .gst-features {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-bottom: 35px;
        }

        .gst-feature {
          font-size: 15px;
          color: #222;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .check-icon {
          color: #22c55e;
          font-size: 16px;
        }

        /* Buttons */
        .gst-buttons {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 25px;
        }

        .gst-btn {
          padding: 14px 28px;
          border-radius: 14px;
          text-decoration: none;
          background: linear-gradient(135deg, #0f172a, #334155);
          color: white;
          font-weight: 600;
          transition: 0.35s ease;
          box-shadow: 0 10px 20px rgba(59, 130, 246, 0.2);
        }

        .gst-btn:hover {
          transform: translateY(-4px);
        }

        /* MOBILE RESPONSIVE */
        @media (max-width: 900px) {
          .gst-section {
            padding: 60px 5%;
          }

          .gst-content {
            flex-direction: column;
            padding: 35px 25px;
            text-align: center;
            gap: 40px;
          }

          .gst-text h2 {
            font-size: 34px;
          }

          .gst-buttons {
            justify-content: center;
          }

          .gst-features {
            align-items: center;
          }
        }
      `}</style>
        </section>
    );
};

export default GstCertification;